export const scrollDirections = {
    horizontal: 'horizontal',
    vertical: 'vertical',
};